import React, {useEffect, useState} from 'react';
import FindTimeLink from './FindTimeLink';
import {FindTimeContainerProps} from '@components/calendar/FindTime.types';
import {NylasIntegrationSource} from '@store/nylas/NylasIntegrationSource';

export const FindTimeContainer: React.FC<FindTimeContainerProps> = ({
  coachUserId,
  recipientUserId,
  recipientFirstName,
  meetingMinutes,
  searchWeeks,
  dayOfWeek,
  desiredTime,
  startDate,
  onlyOnTheHour,
  findTimeChoiceMade,
}) => {
  const [showFindTimeLink, setShowFindTimeLink] = useState(false);
  const [recipientHasNylas, setRecipientHasNylas] = useState(false);

  useEffect(() => {
    if (!coachUserId) {
      setShowFindTimeLink(false);
      setRecipientHasNylas(false);
      return;
    }

    const usersToCheckNylas = recipientUserId ? [coachUserId, recipientUserId] : [coachUserId];

    NylasIntegrationSource.fetchNylasConnections(usersToCheckNylas).then(connections => {
      setShowFindTimeLink(connections.get(coachUserId, false));
      setRecipientHasNylas(connections.get(recipientUserId, false));
    });
  }, [coachUserId, recipientUserId]);

  if (!showFindTimeLink) return null;

  return (
    <FindTimeLink
      coachUserId={coachUserId}
      recipientUserId={recipientUserId}
      recipientFirstName={recipientFirstName}
      recipientHasNylas={recipientHasNylas}
      findTimeChoiceMade={findTimeChoiceMade}
      meetingMinutes={meetingMinutes}
      searchWeeks={searchWeeks}
      dayOfWeek={dayOfWeek}
      desiredTime={desiredTime}
      startDate={startDate}
      onlyOnTheHour={onlyOnTheHour}
    />
  );
};
